import React,{Fragment} from 'react';
import OrderItemBlock from './OrderItemBlock'; 

const LoadMoreExistingOrderItems = (props) => {
    return (
        <Fragment>
            <OrderItemBlock
                list={props.Orders}
                handelOnClickExistingOrder={props.handelOnClickExistingOrder}
            />
            {
                props.total_existing_orders > 0 && props.total_existing_orders > props.Orders.length ?
                    <tr className="load_more_container text-center">
                        <td colSpan="4">
                            <div className="cursor-pointer"  onClick={()=> props.onClickHandleLoadMoreExistingOrderItems()}><i className="fas fa-angle-down show-more"></i></div>
                        </td>
                        {/* <span onClick={()=> props.loadMore()}>
                            Load More
                        </span> */}
                    </tr>
                :null
            }
            

    
        </Fragment>
    );
};

export default LoadMoreExistingOrderItems;